<template>
  <div id="footer">
    <a id="logo" href="#"><img src="@/assets/logo.svg" alt="Clavo"/></a>

    <div>
      <p>
        {{ $t("copyrightsYear", { year: "2023" }) }}<br />{{
          $t("allRightsReserved")
        }}
      </p>
      <p v-html="$t('madeWithLove')"></p>
    </div>
    <div>
      <p>
        {{ $t("anyQuestions") }}<br />{{ $t("writeUsAnEmailTo") }}
        <a href="mailto:hello@clavo.app">hello@clavo.app</a>
      </p>
      <p>
        <router-link to="/Privacy">
          {{ $t("privacyPolicy") }}
        </router-link>
        |
        <router-link to="/TOS">
          {{ $t("termsOfService") }}
        </router-link>
      </p>
    </div>
    <div class="links">
      Find out more:<br>
      <router-link to="/remote-work-management">Remote work management</router-link><br>
      <router-link to="/timezones-management-for-teams">Time zones management for teams</router-link><br>
      <router-link to="/flex-time-management">Flex time management</router-link>

    </div>
  </div>
</template>

<script>
export default {
  props: {},
};
</script>

<style lang="scss" scoped>
#footer {
  font-family: $semibold;
  font-size: 14px;
  line-height: 22px;
  padding: 30px var(--gutter) 48px;
  overflow: hidden;
  max-width: $maxWidth;
  margin: 0 auto;

  @include respond-above(md) {
    padding: 80px 0;
  }

  #logo {
    display: block;
    margin-bottom: 30px;
    img {
      display: block;
      width: 130px;
    }
  }

  p {
    margin-bottom: 8px;
    span {
      color: $red;
    }
  }

  div {
    margin-bottom: 26px;
    @include respond-above(sm) {
      float: left;
      width: 33%;
      padding-left: 20px;

      &:first-of-type {
        // width: 40%;
        padding-left: 0;
      }
      
    }
  }
  .links {
    
    a {
      // color: $black;
    }
  }
}
</style>
